export const LanguageLocalDatepicker = {
    es: 'es-mx',
    en: 'en-gb',
    pt: 'pt'
}